/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useMemo } from 'react'
import classNames from 'classnames'
import { BatchItem } from 'component'
import { useDeepCompareEffect } from 'ahooks'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { ossImg } from 'meinian-package/src/utils/image'
import moment from 'moment'
import Icon from 'meinian-package/src/component/icon'
import util from 'meinian-package/src//utils/util'
import ImageDetail from 'view/detail/imageDetail'
import { getViewConfig, CONFIG_KEY } from 'view/detail/imageDetail/infoView/info/originalText/config'
import { hasFromData } from 'view/detail/imageDetail/infoView/info/originalText'
import { Layer } from '../image.base'
import OriginLink from '../../originLink'
import { StyleStateLabel } from '../styleInfo'
import styles from './index.module.less'

export default (props) => {
  const {
    minWidth,
    outerIndex,
    isBatch,
    columnWidth,
    onClickCard,
    total,
    maxHeight = 500,
    data = [],
    // trackSourceType, // 埋点来源类型
    itemData: _itemData,
    viewConfig = {}, // 视图设置
  } = props

  const [visible, setVisible] = useState()
  const [index, setIndex] = useState(outerIndex)
  const [itemData, setItemData] = useState(_itemData)

  useDeepCompareEffect(() => {
    setItemData(_itemData)
  }, [_itemData])

  useEffect(() => {
    setIndex(outerIndex)
  }, [outerIndex])

  const onChangeIndex = (_outerIndex) => {
    setIndex(_outerIndex)
    props.onChangeIndex && props.onChangeIndex(_outerIndex)
  }
  const _onChange = (success, itemParams) => {
    if (success) {
      if (_itemData.imageGroupEntityId === data[index].imageGroupEntityId) {
        setItemData(pre => ({ ...pre, ...itemParams }))
      }
      props.onResize?.()
    }
  }
  const { config } = getViewConfig(_itemData.platformId, _itemData.isFromZkPlatform)
  if (!config) {
    return
  }
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []

  const infoHeight = useMemo(() => {
    let _height = 126
    if (!infoBlock.length || !viewConfig.originalInfo) {
      _height -= 30
    }
    if (!itemData?.imageEntityExtend?.styleTitle) {
      _height -= 24
    }
    return _height
  }, [itemData])

  const auth = itemData?.loginUserInfo?.inspirationPermissions || []
  const cardHeight = viewConfig.imageTextType === 'proportionally' ? columnWidth + infoHeight : Math.round((columnWidth * itemData.height) / itemData.width) + infoHeight

  return <div
    style={{
      background: '#fff',
      borderRadius: '9px',
      overflow: 'hidden',
      minWidth,
      width: columnWidth,
      height: cardHeight,
      maxHeight,
    }}
  >
    {
      isBatch ? <div
        className={classNames('meinian-waterfall-card-image')}
        style={{ height: `calc(100% - ${infoHeight}px)` }}
      >
        <div className="batch-mask">
          <BatchItem keyValue={`${itemData.imageGroupEntityId},${itemData.inspirationId}`} className="batch-check" info={data[outerIndex]} />
        </div>
        <img loading="lazy" src={ossImg(itemData.mainUrl, 400)} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div> : <div
        className={classNames('meinian-waterfall-card-image')}
        style={{ height: `calc(100% - ${infoHeight}px)` }}
        onClick={e => {
          if (window.location.pathname.startsWith('/meinian/home/workbench')) {
            util.track('mn-workbench-click', {
              module1: '款式查看',
              module2: props.trackModule2,
              module3: '款式详情',
            })
          }
          onClickCard ? onClickCard(itemData, e) : setVisible(true)
        }}
      >
        {
          columnWidth >= 180 && <Layer
            {...props}
            hiddenMark={viewConfig.markInfo}
            onChange={_onChange}
            itemData={itemData}
          />
        }
        <img
          loading="lazy"
          src={ossImg(itemData.mainUrl, 400)}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
        <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
      </div>
    }
    <Info
      item={itemData}
      infoHeight={infoHeight}
      viewConfig={viewConfig}
    />
    {visible ? <ImageDetail
      outerIndex={index}
      listLength={total || data.length}
      onChangeIndex={onChangeIndex}
      visible={visible}
      blogId={data?.[index].imageGroupEntityId}
      inspirationId={data?.[index].inspirationId}
      collectId={data?.[index].collectId}
      onChange={_onChange}
      onVisibleChange={(_visible) => {
        if (!_visible && _itemData.imageGroupEntityId !== data[index].imageGroupEntityId) {
          props.initWaterfall?.()
          props.initSubColls?.()
        }
        setVisible(_visible)
        setIndex(outerIndex)
      }}
      onDeleteItem={props.onDeleteItem}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}
const Info = (props) => {
  const {
    infoHeight,
    viewConfig,
    item,
  } = props
  const { config, dtoConfig } = getViewConfig(item.platformId, item.isFromZkPlatform)
  const dto = item?.[dtoConfig?.dto]
  const sourTime = config?.[CONFIG_KEY.OPTION_ITEM]?.find(i => i.valueKey === 'sourceTime')
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []

  return <div className={styles['mn-waterfall-image-detail-info']} style={{ height: infoHeight }}>
    { item?.imageEntityExtend?.styleTitle ? <div className="style-title">{item?.imageEntityExtend?.styleTitle}</div> : null}
    <div className="mn-waterfall-image-detail-info-1">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span className="user-name">{item.userName}</span>
        <span style={{ color: 'var(--m-text-3)', margin: '0 4px' }}>采自</span>
        {
          dtoConfig && <OriginLink
            style={{ color: '#0065D9' }}
            item={item}
            className="platformOriginLink"
            platformId={item.platformId}
          >
            {dtoConfig?.label || item[dtoConfig?.labelKey]}
          </OriginLink>
        }
      </div>
    </div>
    <div className="mn-waterfall-image-detail-info-2">
      <div className="mn-waterfall-image-detail-info-2-left">
        <Icon type="m-wenjianjia" className="info-inspiration-path-wrap-icon" />
        <Tooltip title={item.inspirationNamePath}><div className="info-inspiration-path text-overflow">{item.inspirationNamePath}</div></Tooltip>
      </div>
      <div style={{ color: 'var(--m-text-1)' }}>{moment(item.sourceTime).format('YYYY/MM/DD')}{sourTime?.label.slice(0, 2)}</div>
    </div>
    {
      viewConfig.originalInfo && dto && !!infoBlock.length && <div className="mn-waterfall-image-detail-info-3"><div className="datum">
        {infoBlock.map(blockInfo => <span className="data-item"><Tooltip placement="bottom" title={blockInfo.label}><Icon type={blockInfo.icon} /></Tooltip><span className="data-item-num">
          {
          // eslint-disable-next-line react/jsx-no-useless-fragment
          Array.isArray(blockInfo.valueKey) ? <>
            { `${hasFromData(blockInfo, dto[blockInfo.valueKey[0]])}/${hasFromData(blockInfo, dto[blockInfo.valueKey[1]])}`}
          </> : <>
            {hasFromData(blockInfo, dto[blockInfo.valueKey])}
          </>
        }
        </span></span>)}
      </div> </div>
    }
  </div>
}
